const CapabilityTable = () => {
  const switcher = document.querySelector(".capability-list__table-switcher");
  const switcherText = document.querySelector(".capability-list__table-switcher span");
  const table = document.querySelector(".capability-list__table-wrapper");

  if (switcher && table) {
    const showText = switcher.getAttribute("data-show-name") || "Show";
    const hideText = switcher.getAttribute("data-hide-name") || "Hide";

    switcher.addEventListener("click", () => {
      const isOpened = table.classList.toggle("opened");
      switcher.classList.toggle("opened");

      switcherText.textContent = isOpened ? hideText : showText;
    });
  }
};

export default CapabilityTable;